import { render, staticRenderFns } from "./permiss.vue?vue&type=template&id=5c3d55da&scoped=true&"
import script from "./permiss.vue?vue&type=script&lang=js&"
export * from "./permiss.vue?vue&type=script&lang=js&"
import style0 from "./permiss.vue?vue&type=style&index=0&id=5c3d55da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3d55da",
  null
  
)

export default component.exports